
  import { Component, Vue } from 'vue-property-decorator';
  import tabs from '@/views/dashboard/config/drawerTabs';
  import { Drawer } from '@/views/interfaces/vuetify/drawer.interface'
import { TranslateResult } from 'vue-i18n';
  import { ProfileRepositoryInterface } from "@/services/Users-profile/interfaces";

  type Shortcut = {
    icon?: string;
    title: TranslateResult;
    to: string;
  };

  type ShortcutGroup = {
    icon?: string;
    title: TranslateResult;
    shortcuts: Shortcut[];
  }

  @Component({
    inject: [
      'profileRepository',
    ],
  })
  export default class DashboardDashboard extends Vue {
    private readonly profileRepository!: ProfileRepositoryInterface;

    private async created(): Promise<void> {
      if (!this.$store.getters.id) {
        return;
      }

      try {
        const notifications = await this.profileRepository.getProfileNotifications();

        if (notifications) {
          this.$store.commit('SET_NOTIFICATIONS', notifications);
        }
      } catch (e) {
        console.log(e);
      }
    }

    private mapDrawerToShortcutGroup(drawer: Drawer): ShortcutGroup {
      return {
        icon: drawer.icon,
        title: this.$t(drawer.title),
        shortcuts: drawer.children.map(child => ({
          icon: child.icon,
          title: this.$t(child.title),
          to: 'to' in child
            ? drawer.group + child.to
            : child.toFixed,
        })),
      };
    }
    public readonly shortcuts: ShortcutGroup[] = tabs()?.map(this.mapDrawerToShortcutGroup) ?? [];
  }
